import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Address } from 'src/app/models/address.model';
import { Router } from '@angular/router';
import { SharedDataService } from 'src/app/services/sharedDataService.service';
@Component({
  selector: 'cart-address',
  templateUrl: './cart-address.component.html',
  styleUrls: ['./cart-address.component.less']
})
export class CartAddressComponent implements OnInit {
  @Input() addressList: Address[] = []; 
  @Output() addressSelected: EventEmitter<Address> = new EventEmitter<Address>();
  @Output() handleCloseAddress: EventEmitter<string> = new EventEmitter<string>();
  address:string="";
  searchResults: Address[] = []; 
  isDealerPortal: boolean = false;
  constructor(
    private message: NzMessageService,
    private translate:TranslateService,
    private sharedData: SharedDataService,
    private router: Router, ) {
      this.sharedData.currentData.subscribe(data => {
        this.isDealerPortal = data.isDealerPortal;
      });
    }
  ngOnInit(): void {
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['addressList']) {
      this.handleSearchByAddress();
    }
  }

   sortAddressesByDefault(addressList:Address[]) {
    return addressList.sort((a, b) => {
      if (a.userDefault && !b.userDefault) {
        return -1;
      }
      if (!a.userDefault && b.userDefault) {
        return 1; 
      }
      return 0;
    });
  }
  handleSearchByAddress():void{
    if (!this.address) {
      //No search filter, show all addresses.
      this.searchResults = this.addressList; 
    } else {
    this.searchResults = this.addressList.filter((addressItem:Address) => {
      const searchTerm = this.address.trim().toLowerCase();
      return (
        addressItem.customerCode.toLowerCase().includes(searchTerm) ||
        addressItem?.customerName?.toLowerCase().includes(searchTerm) ||
        addressItem?.street?.toLowerCase().includes(searchTerm) ||
        addressItem?.mobilePhone?.toLowerCase().includes(searchTerm)
      );
    });
  }
}
  chooseAddress(chooseAddress:Address,choosed:boolean):void{
    this.addressList.forEach((address, i) => {
      if (address.customerCode === chooseAddress.customerCode) {
        address.isChoose = choosed;
      } else {
        if(choosed){
          address.isChoose = false;
        }
      }
    });
  }

  goAddress():void{
    const country = localStorage.getItem("country");
    const data = JSON.parse(localStorage.getItem('customer') || '');
    // 获取目标路由的完整URL
    let prefix = '';
    if(this.isDealerPortal) {
      prefix = 'Dealerportal';
    } else {
      prefix = 'Salesportal';
    }
    const url = this.router.serializeUrl(this.router.createUrlTree([`${prefix}/${country}/myAccount/sold-to-detail`, { 
      customerCode: data?.customerCode || '', 
      ch3Name: data?.ch3Name || '', 
      soldToNo: data?.customerCode || '',
      soldToName: data?.customerName || '',
      salesArea: `${data.salesOrganization}_${data.distributionChannel}_${data.division}`,
    }]));
    
    // 打开新窗口或标签
    window.open(url, '_blank');
  }
  editAddress(index:number):void{
    
  }
  saveAddress(){
    const chosenAddress = this.addressList.find(address => address.isChoose);
    if (chosenAddress) {
      this.addressSelected.emit(chosenAddress);
    } else {
      this.message.create('warning', this.translate.instant('PLEASE_CHOOSE_ADDRESS'));
    }
  }
  closeModal(){
    this.handleCloseAddress.emit();
  }
  onClear(): void {
    this.address="";
    this.searchResults = this.addressList;
  }

}
